'use client'
import Hamburger from 'hamburger-react'
import { FC, useEffect, useState } from 'react'

import { getAppLink } from '@/lib/helpers'
import { CtaItem, NavigationItem } from '@/lib/navigationLinks'

import LinkButton from '../common/LinkButton/LinkButton'
import NavButton from '../common/NavButton/NavButton'
import MobileNavMenu from './MobileNavMenu'
import { usePathname } from 'next/navigation'
import LinkWithQuery from '@/components/LinkWithQuery'

type Props = {
  navItems: NavigationItem[]
  ctaItems: CtaItem[]
  translations: {
    linkMondayPartnership: string
    linkAppStore: string
  }
  isPartnership: boolean
  applessOnly: boolean
  partnershipApplyPath: string
}

const HamburgerMenu: FC<Props> = ({
  navItems,
  ctaItems,
  translations,
  isPartnership,
  applessOnly,
  partnershipApplyPath,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const pathname = usePathname()
  useEffect(() => {
    setIsOpen(false)
  }, [pathname])

  const renderMobileLinks = (links: (NavigationItem | CtaItem)[]) =>
    links.map((link) => {
      if ('menuItems' in link) {
        return (
          <MobileNavMenu
            key={link.label}
            label={link.label}
            path={link.path}
            menuItems={link.menuItems}
          />
        )
      } else if ('label' in link) {
        return (
          <LinkWithQuery
            key={link.label}
            href={link.path}
            className="block w-full text-red-torch underline"
          >
            {link.label}
          </LinkWithQuery>
        )
      }
      return null
    })

  return (
    <div className="lg:hidden z-40">
      <div className="-mt-0.5">
        <Hamburger
          color="white"
          toggled={isOpen}
          toggle={setIsOpen}
          label="hamburger menu"
        />
      </div>

      {isOpen && (
        <div className="fixed inset-0 bg-white top-20">
          <div className="overflow-x-scroll flex flex-col gap-8 h-full text-sm leading-7 font-semibold px-8 pb-40 pt-8 scrollbar-none">
            {renderMobileLinks([...ctaItems, ...navItems])}
            <div className="mt-4">
              {isPartnership ? (
                <NavButton
                  id="nav-apply-book_mo"
                  href={partnershipApplyPath}
                  className="w-full"
                  size="sm"
                >
                  {translations.linkMondayPartnership}
                </NavButton>
              ) : (
                <LinkButton
                  id="nav-get-in-touch"
                  href={getAppLink(applessOnly)}
                  size="sm"
                  className="w-full"
                >
                  {translations.linkAppStore}
                </LinkButton>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default HamburgerMenu
